import { useFormatCurrency } from '@udemy/ud-data';
import React from 'react';
/** React props interface for `FormattedCurrency` component. */

/**
 * ### FormattedCurrency
 *
 * @remarks
 * Returns result of `@udemy/ud-data`'s `formatCurrency` function, wrapped in a `<span>` element.
 */
export const FormattedCurrency = _ref => {
  let {
    value,
    ...opts
  } = _ref;
  const {
    formatCurrency
  } = useFormatCurrency();
  return /*#__PURE__*/React.createElement("span", null, formatCurrency(value, opts));
};
//# sourceMappingURL=formatted-currency.react-component.js.map